import clsx from "clsx";
import { KeyboardEvent } from "react";
import { BiBath } from "react-icons/bi";
import { PropertyDetails } from "./cardChips";
import { IoBedOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { HiArrowsPointingOut } from "react-icons/hi2";
import { formatPrice } from "../../../utils/formatPrice";
import { useStatus } from "../../common/hooks/useStatus";
import { formatDate } from "../../../utils/dateFormatter";
import { useMapStore } from "../../../stores/mapCordinations";
import { formatPropertyType } from "../../../utils/formatPropertyType";
import { convertToFormattedAmount } from "../../../utils/convertAmount";
import {
  LastStatusEnum,
  type ListingCard,
} from "../../../services/exploreListings";

import "swiper/css";

interface MapCardProps {
  property: ListingCard;
  handleShadow?: boolean;
}

const FallbackImage =
  "data:image/jpeg;base64,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";

const MapCard = ({ property, handleShadow = true }: MapCardProps) => {
  const { setShowProperty, setPassListingId } = useMapStore();
  const status = useStatus(property?.lastStatus);

  const navigate = useNavigate();

  const truncateAddress = (address: string, maxLength: number) => {
    if (address.length > maxLength) {
      return `${address.slice(0, maxLength)}...`;
    }
    return address;
  };

  const propertyImg =
    property.images && property.images.length > 1
      ? property.images[0]
      : property.displayImageUrl
      ? property.displayImageUrl
      : FallbackImage;

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>, id: string) => {
    if (event.key === "Enter" || event.key === " ") {
      navigate(`/listings/${id}`);
    }
  };

  const handleListingClick = (id: string) => {
    setShowProperty(() => true);
    setPassListingId(id);
  };
  const isSold = [
    LastStatusEnum.Sold,
    LastStatusEnum.SoldConditionally,
    LastStatusEnum.SoldConditionallyWithEscapeClause,
  ].includes(property?.lastStatus);

  return (
    <div
      className={clsx(
        "bg-white rounded-[10px] border border-[#F0F0F0] cursor-pointer flex flex-col w-[320px]",
        handleShadow ? "shadow-xl" : ""
      )}
      onClick={() => handleListingClick(property.listingId)}
      onKeyDown={(event) => handleKeyPress(event, property.listingId)}
    >
      <div className="h-[180px] min-h-[180px] w-full relative">
        <img
          src={propertyImg}
          alt={property.listingId}
          className="w-full h-full object-cover rounded-t-[10px] border border-[#F0F0F0] border-b-0"
          onError={(e) => {
            e.currentTarget.src = FallbackImage;
            e.currentTarget.alt = "Image not available";
          }}
        />
        {property.propertyType && (
          <div className="absolute top-3 left-3 bg-[#368014] text-xs font-medium rounded-md text-white py-[6px] px-[10px]">
            {formatPropertyType(property.propertyType)}
          </div>
        )}
        <div
          className={clsx(
            "text-xs flex px-[10px] py-1 rounded-md bg-white items-center absolute bottom-3 left-3 h-[28px]",
            isSold ? "text-[#FF5757]" : "text-[#368014]"
          )}
        >
          <div className="font-bold">{status.state}</div>
          <div
            className={clsx(
              "h-3 w-px mx-3",
              isSold ? "bg-[#FF5757]" : "bg-[#368014]"
            )}
          />
          <div className="font-normal">
            {!isSold
              ? property.listDate
                ? formatDate(property.listDate)
                : "Unknown date"
              : property.soldDate
              ? formatDate(property.soldDate)
              : "Unknown date"}
          </div>
        </div>
      </div>
      {!isSold && (
        <div className="bg-[#368014] flex py-1 px-4 items-center text-white justify-between border-x border-[#F0F0F0]">
          <div className="font-semibold text-xs">Down Payment Boost</div>
          <div className="font-bold text-sm">
            {`${
              property.downPaymentBoost
                ? `$${formatPrice(
                    convertToFormattedAmount(property.downPaymentBoost)
                  )}`
                : "N/A"
            }`}
          </div>
        </div>
      )}
      <div className="flex-1 flex flex-col pt-2 border border-[#F0F0F0] rounded-b-[10px] justify-between">
        <div className="w-full relative px-2 text-xs text-black flex items-center justify-between mb-1">
          {!isSold && (
            <div className="flex-1 text-[20px] text-black font-bold flex items-center">
              {property.listPrice
                ? `$${formatPrice(
                    convertToFormattedAmount(property.listPrice)
                  )}`
                : "N/A"}
            </div>
          )}
          <div
            className={clsx(
              "flex items-center gap-2",
              isSold ? "text-[#FF5757]" : "text-[#368014]"
            )}
          >
            {(property.listPrice || property.soldPrice) && (
              <div className="text-[20px] font-bold">
                {!isSold
                  ? `$${formatPrice(
                      convertToFormattedAmount(
                        (property.minDownPayment ?? 0) -
                          (property.downPaymentBoost ?? 0)
                      )
                    )}`
                  : property.soldPrice
                  ? `$${formatPrice(
                      convertToFormattedAmount(property.soldPrice)
                    )}`
                  : "N/A"}
              </div>
            )}
            <div
              className={clsx(
                "line-through text-base font-light pt-1",
                isSold && "text-z-shark"
              )}
            >
              $
              {isSold
                ? property?.listPrice
                  ? formatPrice(convertToFormattedAmount(property.listPrice))
                  : "N/A"
                : property?.minDownPayment
                ? formatPrice(convertToFormattedAmount(property.minDownPayment))
                : "N/A"}
            </div>
          </div>
        </div>

        <div className="flex items-center px-2 justify-between">
          {property.displayAddress && (
            <div className="text-sm text-z-shark my-1">
              {truncateAddress(property.displayAddress, !isSold ? 15 : 300)}
            </div>
          )}
          {!isSold && (
            <div className="text-sm text-z-shark">Min. Down Payment</div>
          )}
        </div>

        <div className="text-sm h-[42px] flex items-center justify-between border-t border-[#ECECEC] mt-2">
          <div className="px-2 flex items-center w-full">
            <div className="flex items-center gap-1 justify-center text-nowrap flex-1">
              <IoBedOutline className="text-[#C8C8C8] text-xl" />
              <PropertyDetails
                customClassName="justify-center"
                label="Beds"
                value={
                  property.numBedrooms
                    ? `${property.numBedrooms.toString()}`
                    : "N/A"
                }
              />
            </div>
            <div className="w-px h-8 bg-[#ECECEC] mx-2" />
            <div className="flex items-center gap-1 justify-center text-nowrap flex-1">
              <BiBath className="text-[#C8C8C8] text-xl" />
              <PropertyDetails
                customClassName="justify-center"
                label="Baths"
                value={
                  property.numBathrooms
                    ? `${property.numBathrooms.toString()}`
                    : "N/A"
                }
              />
            </div>
            <div className="w-px h-8 bg-[#ECECEC] mx-2" />
            <div className="flex items-center gap-1 justify-center text-nowrap flex-1">
              <HiArrowsPointingOut className="text-[#C8C8C8] text-xl" />
              <PropertyDetails
                label="Sqft"
                value={
                  property.sqft ? `${formatPrice(property.sqft)} sqft` : "N/A"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MapCard };
